import { render, staticRenderFns } from "./CommPVTransDetail.vue?vue&type=template&id=d07e8544&"
import script from "./CommPVTransDetail.vue?vue&type=script&lang=js&"
export * from "./CommPVTransDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports